import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import {
    Form,
    FormActions,
    FormDropdown,
    FormFields,
    FormNumberTextField,
    FormTextField,
    Stack
} from "sprint-common-web";

import { AspectType } from "../../../context/EncodeSpecificationItem";
import { useCreateEncodeSpecificationForm } from "./useCreateEncodeSpecificationForm";

export interface CreateEncodeSpecificationMpeg1FormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface CreateEncodeSpecificationMpeg1FormInputs {
    name: string;
    framerate23_976: string;
    framerate24: string;
    framerate25: string;
    framerate29_97: string;
    framerate30: string;
    framerate50: string;
    framerate59_94: string;
    framerate60: string;
    framerateOther: string;
    slug: number;
    aspectType: AspectType;
    targetAspectRatioId: "";
}

export const CreateEncodeSpecificationMpeg1Form: FunctionComponent<CreateEncodeSpecificationMpeg1FormProps> = (
    props: CreateEncodeSpecificationMpeg1FormProps
) => {
    const { errors, control, formState, reset, handleSubmit } = useForm<CreateEncodeSpecificationMpeg1FormInputs>({
        defaultValues: {
            name: "",
            framerate23_976: "",
            framerate24: "",
            framerate25: "",
            framerate29_97: "",
            framerate30: "",
            framerate50: "",
            framerate59_94: "",
            framerate60: "",
            framerateOther: "",
            slug: undefined,
            aspectType: AspectType.FullFrame,
            targetAspectRatioId: ""
        },
        criteriaMode: "all"
    });
    const {
        manzanitaPresetOptions,
        validateNameUnique,
        createEncodeSpecMpeg1,
        aspectTypesOptions,
        aspectRatioOptions
    } = useCreateEncodeSpecificationForm();

    const handleCreateEncodeSpecification = async (inputs: CreateEncodeSpecificationMpeg1FormInputs) => {
        await createEncodeSpecMpeg1(inputs);
        props.onSubmit();
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        props.onCancel();
    };

    return (
        <Stack>
            <Form onSubmit={handleSubmit(handleCreateEncodeSpecification)}>
                <Stack verticalAlign="space-between">
                    <FormFields>
                        <FormTextField
                            label="Name"
                            control={control}
                            name="name"
                            errors={errors}
                            rules={{
                                required: "Name is required field",
                                validate: validateNameUnique
                            }}
                        />
                        <FormDropdown
                            label={"Framerate 23.976"}
                            name={"framerate23_976"}
                            control={control}
                            errors={errors}
                            options={manzanitaPresetOptions}
                            rules={{
                                required: "Select preset for framerate 23.976"
                            }}
                        />
                        <FormDropdown
                            label={"Framerate 24"}
                            name={"framerate24"}
                            control={control}
                            errors={errors}
                            options={manzanitaPresetOptions}
                            rules={{
                                required: "Select preset for framerate 24"
                            }}
                        />
                        <FormDropdown
                            label={"Framerate 25"}
                            name={"framerate25"}
                            control={control}
                            errors={errors}
                            options={manzanitaPresetOptions}
                            rules={{
                                required: "Select preset for framerate 25"
                            }}
                        />
                        <FormDropdown
                            label={"Framerate 29.97"}
                            name={"framerate29_97"}
                            control={control}
                            errors={errors}
                            options={manzanitaPresetOptions}
                            rules={{
                                required: "Select preset for framerate 29.97"
                            }}
                        />
                        <FormDropdown
                            label={"Framerate 30"}
                            name={"framerate30"}
                            control={control}
                            errors={errors}
                            options={manzanitaPresetOptions}
                            rules={{
                                required: "Select preset for framerate 30"
                            }}
                        />
                        <FormDropdown
                            label={"Framerate 50"}
                            name={"framerate50"}
                            control={control}
                            errors={errors}
                            options={manzanitaPresetOptions}
                            rules={{
                                required: "Select preset for framerate 50"
                            }}
                        />
                        <FormDropdown
                            label={"Framerate 59.94"}
                            name={"framerate59_94"}
                            control={control}
                            errors={errors}
                            options={manzanitaPresetOptions}
                            rules={{
                                required: "Select preset for framerate 59.94"
                            }}
                        />
                        <FormDropdown
                            label={"Framerate 60"}
                            name={"framerate60"}
                            control={control}
                            errors={errors}
                            options={manzanitaPresetOptions}
                            rules={{
                                required: "Select preset for framerate 60"
                            }}
                        />
                        <FormDropdown
                            label={"Framerate Other"}
                            name={"framerateOther"}
                            control={control}
                            errors={errors}
                            options={manzanitaPresetOptions}
                            rules={{
                                required: "Select preset for framerate Other"
                            }}
                        />
                        <FormDropdown
                            label={"Aspect type"}
                            name={"aspectType"}
                            control={control}
                            errors={errors}
                            options={aspectTypesOptions}
                            rules={{
                                required: "Select aspect type"
                            }}
                        />
                        <FormDropdown
                            label={"Target aspect ratio"}
                            name={"targetAspectRatioId"}
                            control={control}
                            errors={errors}
                            options={aspectRatioOptions}
                            rules={{
                                required: "Select target aspect ratio"
                            }}
                        />
                        <FormNumberTextField label="Slug" control={control} name="slug" errors={errors} />
                    </FormFields>
                    <FormActions
                        isLoading={formState.isSubmitting || formState.isValidating}
                        onCancel={handleCancelButtonClick}
                    />
                </Stack>
            </Form>
        </Stack>
    );
};
